import { request } from "./index.js";
import { apiFms } from "./config.js";
// 付款申请单-草稿分页列表
export async function fundDaily(params) {
  return request({
    method: `post`,
    url: `${apiFms}/fundingFlow/daily`,
    data: { ...params }
  })
}
